const DEFAULTS = {
  teamName: '音愈童心',
  platformName: '沁心笛音智能互动教学辅助平台',
  adminTitle: '音愈童心管理后台',
  footer: '音愈童心 · 沁心笛音智能互动教学辅助平台',
  logoUrl: '',
  faviconUrl: '',
  ogImage: '',
  slogan: '用笛子，把世界吹给孩子听',
  icp: '黔ICP备2024025391号-1',
  practiceUrl: '',
  siteUrl: '',
  keywords: ''
}

function applyFavicon(url) {
  if (typeof document === 'undefined' || !url) return
  let link = document.querySelector("link[rel='icon']")
  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'icon')
    document.head.appendChild(link)
  }
  link.setAttribute('href', url)
}

const brand = {
  namespaced: true,
  state: {
    ...DEFAULTS,
    loaded: false
  },
  mutations: {
    setBrand (state, payload = {}) {
      Object.keys(DEFAULTS).forEach(key => {
        if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
          state[key] = payload[key]
        }
      })
      if (!state.faviconUrl && state.logoUrl) {
        state.faviconUrl = state.logoUrl
      }
      state.loaded = true
      window.SITE_CONFIG = window.SITE_CONFIG || {}
      window.SITE_CONFIG.brand = {
        teamName: state.teamName,
        platformName: state.platformName,
        adminTitle: state.adminTitle,
        footer: state.footer,
        logoUrl: state.logoUrl,
        faviconUrl: state.faviconUrl,
        ogImage: state.ogImage,
        slogan: state.slogan,
        icp: state.icp,
        practiceUrl: state.practiceUrl,
        siteUrl: state.siteUrl,
        keywords: state.keywords
      }
      applyFavicon(state.faviconUrl || state.logoUrl)
    }
  },
  actions: {
    loadBrand ({ commit }, http) {
      if (!http || !http.adornUrl) {
        return Promise.resolve()
      }
      return http({
        url: http.adornUrl('/app/site/info'),
        method: 'get',
        params: http.adornParams({}, false)
      }).then(({ data }) => {
        if (data && (data.code === 0 || data.code === 200) && data.data) {
          commit('setBrand', data.data)
          commit('setActiveName', data.data.teamName || DEFAULTS.teamName, { root: true })
        }
      }).catch(() => {})
    }
  }
}

export default brand
